import {ReactNode} from "react";
import {BadgeVariant} from "@interstate/components/Badge";
import {
  ArrowPathIcon,
  ArrowTopRightOnSquareIcon,
  BuildingOfficeIcon,
  XCircleIcon
} from "@interstate/components/Icons";
import {InterstateToken} from "../../../../../../lib/interstate";
import {BadgeMetadata} from "../../../../../../badges";
import {SpinnerIcon} from "../../../../../../icons";

export type TestEntityStatus =
  | "idle"
  | "queued"
  | "in-progress"
  | "created"
  | "failed";

const variantForStatus = (status: TestEntityStatus): BadgeVariant => {
  switch (status) {
    case "idle":
      return "transparent";
    case "queued":
      return "transparent";
    case "in-progress":
      return "info";
    case "created":
      return "success";
    case "failed":
      return "error";
  }
};

const startIconForStatus = (
  token: InterstateToken,
  status: TestEntityStatus
): ReactNode | undefined => {
  switch (status) {
    case "idle":
      return <BuildingOfficeIcon />;
    case "queued":
      return <ArrowPathIcon />;
    case "in-progress":
      return <SpinnerIcon />;
    case "created":
      return <BuildingOfficeIcon />;
    case "failed":
      return <XCircleIcon />;
  }
};

const endIconForStatus = (status: TestEntityStatus): ReactNode | undefined => {
  if (status === "created") {
    return <ArrowTopRightOnSquareIcon />;
  }
  return undefined;
};

export const createNewEntityBadgeMetadata = (
  token: InterstateToken,
  status: TestEntityStatus
): BadgeMetadata => {
  return {
    labelKey: `create-new-entity.entity-states.${status}`,
    variant: variantForStatus(status),
    startIcon: startIconForStatus(token, status),
    endIcon: endIconForStatus(status)
  };
};
